// extracted by mini-css-extract-plugin
module.exports = {"show-address-pending":"ShowAddressPending_show-address-pending__yKMcs"};